import {useState} from 'react';
import './index.css';
import {useTranslation} from 'react-i18next';
import useDeviceDetect from '../../hooks/useDeviceDetect';
import i18n from '../../i18n';
import {trackLead} from '../../consent/googleAnalytics';

export const titles = {
    'Homepage': 'HOMEPAGE',
    'DMS': 'DMS',
    'TaskIssue': 'TASK & ISSUE MANAGEMENT',
    'InfoManagement': 'INFORMATION MANGEMENT',
    'IFC': 'IFC VIEWER',
    'Cloud': 'CLOUD INFRASTRUCTURE & SECURITY',
    'BIM': 'BIM MODEL MANAGEMENT',
    'PlanManagement': 'PLAN MANAGEMENT',
    'Pricing':'PRICING',
    'Workflows':'WORKFLOWS',
}

function validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
}

function createTemplate(dataContactForm) {
    const { email, name, phone, text } = dataContactForm;
    if (text) {
        return `Email: ${email}\nName: ${name}\n\n${text}`;
    }
    return `Email: ${email}\nName: ${name}\nMobile: ${phone}`;
}

let sending = false;

// Short confirmation or error notice after submitting a form; fixed at the bottom so no form layout changes.
export function showFormNotice(type, messageKey) {
    const previous = document.getElementById('FormNotice');
    if (previous) previous.remove();
    const notice = document.createElement('div');
    notice.id = 'FormNotice';
    notice.className = `FormNotice FormNotice-${type}`;
    notice.setAttribute('role', type === 'error' ? 'alert' : 'status');
    notice.textContent = i18n.t(messageKey);
    document.body.appendChild(notice);
    setTimeout(() => notice.remove(), type === 'error' ? 8000 : 6000);
}

export async function sendMessage(dataContactForm, funcFinish, subjectPreTitle, page, successKey = 'FormSuccess') {
    if (!validateEmail(dataContactForm.email)) {
        showFormNotice('error', 'FormInvalidEmail');
        return false;
    }
    if (sending) return false;
    sending = true;
    showFormNotice('info', 'FormSending');
    try {
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                to: dataContactForm.email,
                subject: `${subjectPreTitle}${titles[`${page}`] || 'WEBSITE'}`,
                text: createTemplate(dataContactForm)
            })
        };
        const res = await fetch(`${process.env.REACT_APP_LINK}/send-email`, requestOptions);
        if (res.status !== 200) {
            showFormNotice('error', res.status === 429 ? 'FormTooMany' : 'FormError');
            return false;
        }
        trackLead(subjectPreTitle.replace('/', '').trim(), page);
        showFormNotice('success', successKey);
        if (typeof funcFinish === 'function') funcFinish();
        return true;
    } catch (e) {
        showFormNotice('error', 'FormError');
        return false;
    } finally {
        sending = false;
    }
}

const ContactUsForm = ({page}) => {
    const {t} = useTranslation();
    const mobile = useDeviceDetect();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState('');

    return (
        <div className={'ContactUsWrapper'}>
            <div className={'ContactUsContainer'}>
                <div className={'ContactUsBackgroundPhoto'}/>
                <h5>{t('ContactUsTitle')}</h5>
                <form autoComplete="on" className={'ContactUsForm'}>
                    <h6>{t('ContactUsFormTitle')}</h6>
                    <p>{t('ContactUsFormDescription')}</p>
                    <div  className={'ContactUsFormInputContainer'} style={{
                        display: `${mobile ? 'block' : 'flex'}`, justifyContent: 'space-between',
                    }}>
                        <input
                            type='email'
                            id='email'
                            name='email'
                            autoComplete='email'
                            className={`${error && !email ? 'errorValue' : ''}`} value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={`${t('Email')}*`}
                        />
                        <input
                            id='FullName'
                            type='text'
                            name='FullName'
                            autoComplete='name' className={`${error && !name ? 'errorValue' : ''}`} value={name} onChange={(e) => setName(e.target.value)}
                               placeholder={`${t('FullName')}*`}/>
                    </div>
                    <textarea value={text} onChange={(e) => setText(e.target.value)} placeholder={`${t('Insert')}*`}/>
                    <button
                        type='submit'
                        onClick={(e) => {
                            e.preventDefault();
                        if (!email || !name) {
                            setError(true);
                            showFormNotice('error', 'FormMissingFields');
                        } else {
                            sendMessage({
                                email, name, text
                            }, () => {
                                setName('');
                                setEmail('');
                                setText('')
                            }, 'REQUEST CONTACT/', page)
                        }
                    }
                    }>{t('Submit')}</button>
                </form>
            </div>
        </div>
    )
}
export default ContactUsForm;